import { LoadingOutlined, RightOutlined } from "@ant-design/icons";
import React, {
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import styles from "../../styles/chat.module.scss";
import { ShowMessage } from "../ShowMessage/ShowMessage";
import copy from "copy-to-clipboard";
import ChatItem from "./chatItem";
import { Skeleton } from "antd";

function ChatpdfLine(
  props: {
    chatContent: any;
    tipClick: (text: string) => void;
    reAsk: (value: string, item: any) => void;
    umlReloadSuccess: (str: string, uuid: string) => void;
    reAnswer: (index: number, uuid: string) => void;
    stop: boolean;
    loading: boolean;
    handleClickRepo: (
      params: {
        type: string;
        repo_full_name: string;
        branch_name: string;
        url?: string;
      },
      action?: "quote" | "preview",
      fileInfo?: {
        openai_file_id?: string;
        original_filename?: string;
      }
    ) => void;
  },
  ref: any
) {
  const {
    chatContent,
    tipClick,
    umlReloadSuccess,
    stop,
    loading,
    handleClickRepo,
  } = props;
  const chatContainerRef = useRef({} as any);
  const autoScroll = useRef(true as boolean);
  const [style, setStyle] = useState<React.CSSProperties>({
    width: document.body.offsetWidth - 280 > 1200 ? 1184 : "calc(100% - 16px)",
  });
  const handleScroll = useCallback(() => {
    if (!chatContainerRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
    const isAtBottom = scrollHeight - scrollTop - clientHeight < 100;
    // setAutoScroll(isAtBottom);
    autoScroll.current = isAtBottom;
  }, []);
  useEffect(() => {
    if (chatContainerRef.current && autoScroll.current) {
      const { scrollHeight, clientHeight } = chatContainerRef.current;
      chatContainerRef.current.scrollTop = scrollHeight - clientHeight;
    }
  }, [chatContent, autoScroll]); // 在 chatContent 或 autoScroll 变化时触发

  const goToBottom = (allways: boolean = false) => {
    if (chatContainerRef.current && (allways || autoScroll.current)) {
      const { scrollHeight, clientHeight } = chatContainerRef.current;
      chatContainerRef.current.scrollTo({
        top: scrollHeight + 999, // 滚动到的垂直位置
        left: 0, // 滚动到的水平位置
        behavior: "smooth", // 平滑滚动
      });
    }
  };
  const handleCopy = (text: string) => {
    copy(text);
    ShowMessage.success("复制成功");
  };
  useEffect(() => {
    const chatContainer = chatContainerRef.current;
    if (chatContainer) {
      chatContainer.addEventListener("scroll", handleScroll);

      return () => {
        chatContainer.removeEventListener("scroll", handleScroll);
      };
    }
  }, [handleScroll]);
  useImperativeHandle(ref, () => {
    return {
      goToBottom,
      setChatWidth: (style: React.CSSProperties) => {
        setStyle(style);
      },
    };
  });
  const handleReAnswer = (index: number, uuid: string) => {
    props.reAnswer(index, uuid);
  };
  const ChatLine = React.useMemo(() => {
    return (
      <div
        className={styles.chatpdfLineContainer}
        ref={chatContainerRef}
        onScroll={handleScroll}
      >
        <div style={style} className={styles.chatpdfLine}>
          {loading ? (
            <div className={styles.skeleton}></div>
          ) : (
            chatContent.map((item: any, index: number) => {
              return (
                <React.Fragment key={`${JSON.stringify(item)}`}>
                  <ChatItem
                    isLast={index === chatContent.length - 1}
                    item={item}
                    handleCopy={handleCopy}
                    goToBottom={goToBottom}
                    thread_id={item.thread_id}
                    reAsk={props.reAsk}
                    umlReloadSuccess={umlReloadSuccess}
                    reAnswer={(uuid) => handleReAnswer(index, uuid)}
                    stop={stop}
                    handleClickRepo={handleClickRepo}
                  />
                  {item.pending && item.text !== "" && (
                    <div style={{ marginLeft: 60 }}>
                      <LoadingOutlined /> 正在回答中...
                    </div>
                  )}
                </React.Fragment>
              );
            })
          )}
        </div>

        {/* {!chatContent[chatContent.length - 1]?.pending &&
          chatContent[chatContent.length - 1]?.user_type !== "user" &&
          !!chatContent[chatContent.length - 1]?.text &&
          chatContent[chatContent.length - 1]?.text !== "loading" && (
            <div className={styles.tipList}>
              {tipList.map((item) => {
                return (
                  <div key={item} className={styles.tipItem}>
                    <div
                      className={styles.tipContent}
                      onClick={() => tipClick(item)}
                    >
                      {item}
                      <RightOutlined style={{ marginLeft: 10 }} />
                    </div>
                  </div>
                );
              })}
            </div>
          )} */}
      </div>
    );
  }, [chatContent, style]);
  return ChatLine;
}
export default React.forwardRef(ChatpdfLine);
